










import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class ToggleButton extends Vue {
  @Prop({ default: false }) private checked?: boolean
  @Prop() private title!: string
}
